import React, { Component, Fragment } from "react"
import productPic from "../../assets/images/no-product-image.png"

import {
  CustomerServices,
  DevelopmentServices,
  UtilityService,
  SampleServices,
  StyleServices,
  PermissionServices,
  FileUploadService
} from "../../services"
import Async from "react-select"

//components
import FileUpload from "../../components/FileUpload/FileUpload"
import Field from "../../components/Common/Field/Field"
import Audit from "../../components/Common/audit"
import Button from "../../components/Buttons/Button"
import PageHeader from "../../components/Page/PageHeader/PageHeader"
import CustomerDeptSelect from "../../components/Field/CustomerDeptSelect"

import Picky from "react-picky"
import "react-picky/dist/picky.css" // Include CSS
import { ButtonCol } from "../../components/ButtonCol"
//css
// import './cad.css'

class DevelopmentCAD extends Component {
  state = {
    action: "",
    _id: "",
    disabled: false,

    prefillData: {
      IMAGETYPE: [],
      CATEGORY: [],
      BORDERTYPE: [],
      SEASONS: [],
      BASICFABRICQUALITY: [],
      CADTYPE: [],
      PRINTEMBTYPE: [],
      COLORREFERENCE: []
    },
    cadReferenceName: "",
    cadReferenceCountName: "",
    cadRefId: [],
    cadReferenceCount: [],
    createOption: false,
    CADId: "",
    uploadCAD: "",
    uploadPatternEmb: "",
    sampleRequestNumbers: [],
    assignedToOptions: [],
    cadObj: {
      cadName: "",
      qr: "",
      cadType: [],
      cadImage: "",
      assignedTo: null,
      sampleRequestId: null,
      cadNumber: null,
      basicFabricQuality: null,
      magnumStyleId: null,
      styleReferenceId: null,
      category: null,
      customer: null,
      customerDepartmentId: null,
      seasons: null,
      storyName: "",
      printType: null,
      borderType: null,
      options: [],
      refImages: []
    },
    cadTypeArr: [],
    selectedOptions: [],
    customerList: [],
    style: {
      customer: null,
      customerDepartmentId: null
    },
    styleInfo: null
  }

  componentWillMount() {
    let { action, _id } = this.props.location.state

    if (action === "view") {
      this.setState({
        disabled: true
      })
    }

    if (_id !== "") {
      DevelopmentServices.getCAD(_id)
        .then(response => {
          if (response.status === 200) {
            let obj = { ...response.text.data }
            // Object.keys(obj).forEach(function (keyn) {
            //   if (keyn in cadObj) {
            //     cadObj[keyn] = response.text.data[keyn]
            //   }
            // })
            this.setState({
              cadObj: obj,
              createOption: obj.options.length ? false : true
            })
            // this.setState({ styleInfo: cadObj.magnumStyleId })
          }
        })
        .catch(error => { })
    }
    this.setState({
      action,
      _id
    })

    this.prefillInfo()
    this.getSampleRqNo("")
    this.getMagnumStyleNo("")

    //actioned By
    PermissionServices.searchEmploye("")
      .then(async response => {
        let actionedByOption = [...response.text.data]
        this.setState({ actionedByOption, isLoading: true })
      })
      .catch(error => this.props.getalertMessage("error", error))

    //Get Customer List
    CustomerServices.customerInfo()
      .then(response => {
        if (response.status === 200) {
          this.setState({ customerList: response.text.data })
        }
      })
      .catch(error => {
        this.props.getalertMessage("error", error.toString())
      })
  }

  componentDidMount() {
    let { action } = this.props.location.state
    if (action === "add") {
      DevelopmentServices.getCadNumber()
        .then(response => {
          if (response.status === 200) {
            const cadNumber = response.text.data.cadNumber
            this.setState({
              cadObj: {
                ...this.state.cadObj,
                cadNumber
              }
            })
            response.status === 401 && this.props.unauthorisedFunc()
          }
        })
        .catch(error => {
          this.props.getalertMessage("error", error.toString())
        })
    }
    this.getSampleRqNo("")

    if (this.state.action === "add") {
      window.addEventListener("beforeunload", function (event) {
        event.returnValue = "Hellooww"
      })
    }
  }

  componentWillUnmount() {
    if (this.state.action === "add") {
      window.removeEventListener("beforeunload", function (event) {
        event.returnValue = "Hellooww"
      })
    }
  }

  prefillInfo = () => {
    DevelopmentServices.prefillDataCadSystem()
      .then(response => {
        if (response.status === 200) {
          this.setState({ prefillData: response.text.data })
        }
        response.status == 401 && this.props.unauthorisedFunc()
      })
      .catch(error => {
        this.props.getalertMessage("error", error.toString())
      })
  }

  saveCAD = e => {
    e.preventDefault()
    let cadObj = { ...this.state.cadObj }
    if (
      cadObj.magnumStyleId !== null &&
      typeof cadObj.magnumStyleId === "object"
    ) {
      cadObj.magnumStyleId = cadObj.magnumStyleId.value
    }
    if (
      cadObj.sampleRequestId !== null &&
      typeof cadObj.sampleRequestId === "object"
    ) {
      cadObj.sampleRequestId = cadObj.sampleRequestId.value
    }
    if (cadObj.assignedTo !== null && typeof cadObj.assignedTo === "object") {
      cadObj.assignedTo = cadObj.assignedTo.value
    }
    if (
      cadObj.styleReferenceId !== null &&
      typeof cadObj.styleReferenceId === "object"
    ) {
      cadObj.styleReferenceId = cadObj.styleReferenceId.value
    }

    cadObj.cadType = cadObj.cadType.map(data => {
      return typeof data !== "string" ? data.value : data
    })

    if (this.state._id !== "") {
      cadObj._id = this.state._id
    }

    DevelopmentServices.createCAD(cadObj)
      .then(response => {
        if (response.status === 200) {
          this.setState({
            createOption: true,
            _id: response.text.data._id
          })
          this.props.getalertMessage("success", response.text.message)
        }
        response.status === 401 && this.props.unauthorisedFunc()
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  createCAD = () => {
    let { cadObj } = this.state
    cadObj.options.push({
      cadRef: null,
      cadName: "",
      cadImage: "",
      colourRefFrom: null,
      colourDetails: "",
      cadRefImages: []
    })
    this.setState({
      cadObj
    })
  }

  createReference = (e, index) => {
    // e.preventDefault()
    let cadObj = { ...this.state.cadObj }
    let options = { ...cadObj.options[index] }
    options.cadId = this.state._id
    DevelopmentServices.createReference(options)
      .then(res => {
        if (res.status === 200) {
          let cad = res.text.data
          this.props.getalertMessage("success", "Cad Reference Updated")
          let cadObj = { ...this.state.cadObj }
          cadObj.options = cad.options
          this.setState({ createOption: false, cadObj })
        }
        res.status == 401 && this.props.unauthorisedFunc()
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  removeCADReference = id => {
    let { cadObj } = this.state
    cadObj.options = cadObj.options.filter(x => x._id != id)
    this.setState({ cadObj })
    DevelopmentServices.removeCADReference(this.state._id, id)
      .then(response => {
        if (response.message === "Operation Successful") {
          this.props.getalertMessage("success", "Cad Reference removed success")

          // this.setState({ cadRefId: this.state.cadRefId.push(a._id) })
        }
      })
      .catch(error => { })
  }

  uploadNewImage = (e, index) => {
    let b = {}
    b = e.target.files[0]
    b.imageName = this.state[`imageInfo${index}`].imageName
    b.imageDescription = this.state[`imageInfo${index}`].imageDescription

    this.setState({ [`uploadNewImage${index}`]: b })
  }

  getMagnumStyleNo = value => {
    DevelopmentServices.getMagnumStyleNoWithReference(value)
      .then(response => {
        if (response.status === 200) {
          let jsonData = []
          response.text.data.map((info, index) => {
            let objData = {}
            objData.label = info.referenceCode
            objData.value = info.referenceId
            jsonData.push(objData)
          })
          this.setState({ styleInfo: jsonData })
        }
      })
      .catch(error => {
        //this.props.getalertMessage('error',error.toString())
      })
  }

  changeStyleNo = styleValue => {
    if (styleValue !== null) {
      let { cadObj } = this.state
      cadObj.styleReferenceId = styleValue.value
      StyleServices.getStyleInfoByReference(styleValue.value)
        .then(response => {
          if (response.status === 200) {            
            cadObj.magnumStyleName = response.text.data.magnumStyleName
            cadObj.customerRefNumber = response.text.data.customerRefNumber
            cadObj.magnumStyleId = response.text.data.magnumStyleId
            cadObj.customer = response.text.data.customer
            cadObj.customerDepartmentId = response.text.data.customerDepartmentId
            this.setState({
              cadObj,
              sampleRequestNumbers: response.text.data.sampleRequest
            })
            if (!response.text.data.sampleRequest || !response.text.data.sampleRequest.length) {
              this.props.getalertMessage(
                "info",
                "This style ref no does'nt have Requests"
              )
            }
          }
          response.status == 401 && this.props.unauthorisedFunc()
        })
        .catch(error => this.props.getalertMessage("error", error.toString()))
    } else {
      let { cadObj } = this.state
      cadObj.styleReferenceId = null
      cadObj.magnumStyleId = null
      cadObj.magnumStyleName = ""
      cadObj.customer = null
      cadObj.customerDepartmentId = null
      this.setState({
        cadObj
      })
    }
  }

  getSampleRqNo = value => {
    SampleServices.getSampleReqNo(value)
      .then(response => {
        if (response.status === 200) {
          this.setState({ sampleRequestNumbers: response.text.data })
        }
        response.status == 401 && this.props.unauthorisedFunc()
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  changeSampleNo = sampleNo => {
    if (
      sampleNo !== null &&
      sampleNo.value !== undefined &&
      sampleNo.value !== ""
    ) {
      SampleServices.getStyleInfo(sampleNo.value)
        .then(response => {
          if (response.status === 200) {
            let cadObj = { ...this.state.cadObj }
            cadObj.sampleRequestId = sampleNo.value
            cadObj.customer = response.text.data.customer
            cadObj.customerDepartmentId =
              response.text.data.customerDepartmentId
            cadObj.magnumStyleId = response.text.data.magnumStyleId._id
            cadObj.styleReferenceId = response.text.data.styleReferenceId
            this.setState({
              cadObj
            })
          } else {
            this.props.getalertMessage("error", response.text.message)
          }
        })
        .catch(error => this.props.getalertMessage("error", error.toString()))
    } else {
      let cadObj = { ...this.state.cadObj }
      cadObj.sampleRequestId = null
      cadObj.customer = null
      cadObj.customerDepartmentId = null
      cadObj.magnumStyleId = null
      cadObj.styleReferenceId = null
      this.setState({
        cadObj
      })
    }
  }

  cadStatus = e => {
    DevelopmentServices.cadStatus(e.target.checked, this.state.CADId)
      .then(response => { })
      .catch(error => {
        this.msg.show("Try Again Later", {
          time: 2000,
          type: "info"
        })
      })
  }

  getCadImages = (cadRefImages, index) => {
    let { cadObj } = this.state
    cadObj.options[index].cadRefImages = cadRefImages
    this.setState({
      cadObj
    })
  }

  //image updload for cad ref images
  imageUploadCadRefImage = (files, index) => {
    FileUploadService.uploadFile(files[0], "cadOptions")
      .then(response => {
        if (response.status === 200) {
          let cadObj = { ...this.state.cadObj }
          cadObj.options[index].cadImage = response.text.data.url
          this.setState({
            cadObj
          })
        } else if (response.status === 401) {
          this.props.unauthorisedFunc()
        } else {
          UtilityService.manualErrorMsg(this.msg, " Something went wrong ")
        }
      })
      .catch(error => { })
  }

  searchAssignedTo = value => {
    if (value !== null) {
      PermissionServices.searchEmploye(value).then(async response => {
        if (response.status == 200) {
          this.setState({
            actionedByOption: [...response.text.data]
          })
        }
      })
    }
  }

  getAssignedTo = data => {
    let cadObj = { ...this.state.cadObj }
    if (data !== null) {
      cadObj.assignedTo = data.value
      this.setState({
        cadObj,
        assignedToObj: data
      })
    } else {
      cadObj.assignedTo = null
      this.setState({
        cadObj,
        assignedToObj: null
      })
    }
  }

  _onChange = (name, value) => {
    let cadObj = { ...this.state.cadObj }
    cadObj[name] = value
    this.setState({
      cadObj
    })
  }

  getRefImages = refImages => {
    let cadObj = { ...this.state.cadObj }
    cadObj.refImages = refImages
    this.setState({
      cadObj
    })
  }

  onMultiSelect = val => {
    let cadTypeArr = []
    cadTypeArr.push(val)
    this.setState({ cadTypeArr })
  }

  handleSelectedChanged = selected => { }

  imageUploadForCad = files => {
    FileUploadService.uploadFile(files[0], "cad")
      .then(response => {
        if (response.status === 200) {
          let cadObj = { ...this.state.cadObj }
          cadObj.cadImage = response.text.data.url
          this.setState({
            cadObj
          })
        } else if (response.status === 401) {
          this.props.unauthorisedFunc()
        } else {
          UtilityService.manualErrorMsg(this.msg, " Something went wrong ")
        }
      })
      .catch(error => { })
  }

  _handleChangeCadType = val => {
    let cadObj = { ...this.state.cadObj }
    cadObj.cadType = val
    this.setState({ cadObj })
  }

  _handleCustDeptChange = (index, customer, customerDepartmentId) => {
    let cadObj = { ...this.state.cadObj }
    cadObj.customer = customer
    cadObj.customerDepartmentId = customerDepartmentId
    this.setState({ cadObj })
  }

  removeCadImageOptions = (e, index) => {
    let { cadObj } = this.state
    cadObj.options[index].cadImage = ""
    this.setState({
      cadObj
    })
  }

  removeCadImage = () => {
    let { cadObj } = this.state
    cadObj.cadImage = ""
    this.setState({
      cadObj
    })
  }

  updateOptionValue = (name, value, index) => {
    let { cadObj } = this.state
    cadObj.options[index][name] = value
    this.setState({
      cadObj
    })
  }

  checkValidation = e => {
    if (
      this.validateArrayObject(this.state.cadObj, "cadName", null) &&
      this.state.cadObj.cadType.length > 0 &&
      this.validateArrayObject(this.state.cadObj, "category", null) &&
      this.validateArrayObject(this.state.cadObj, "printType", null) &&
      this.validateArrayObject(this.state.cadObj, "customer", null) &&
      this.validateArrayObject(this.state.cadObj, "customerDepartmentId", null)
    ) {
      this.saveCAD(e)
    } else {
      this.props.getalertMessage("error", "Please fill all mandatory fields")
    }
  }

  validateArrayObject(data, key, val) {
    let values = data[key] !== val ? true : false
    return values
  }

  render() {
    const { cadObj, prefillData, selectedOptions, style } = this.state
    // let cadType = ""
    // let styleNOInfoVal =
    //   cadObj.magnumStyleId !== null && cadObj.magnumStyleId.label
    // let customerDeptName =
    //   cadObj.customer !== null &&
    //   cadObj.customer.customerDepartmentName +
    //   "-" +
    //   cadObj.customer.customerName

    return (
      <Fragment>
        <div class="right-section bg-white">
          <div class="row nopadding bg-white">
            <div class="col-md-12 nopadding">
              <Audit _id={this.state._id} />
              <PageHeader history={this.props.history} header="3D" />

              <form name="cadInfo" id="test">
                <div class="col-md-12 nopadding">
                  {this.state.CADId !== "" && (
                    <ul class="nav-locator fabric-status">
                      <li>
                        <span for="status">Status</span>
                        <div class="switch switch-mod">
                          <label>
                            <input
                              value="status"
                              class="sample-opt-chckbox"
                              type="checkbox"
                              onChange={e => this.cadStatus(e)}
                            />
                            <span class="lever" />
                          </label>
                        </div>
                      </li>
                    </ul>
                  )}
                </div>
                <div class="col-md-12 p-0">
                  <div class="col-md-3 pl-2">
                    {this.state.cadReferenceName !== "" && (
                      <div class="form-group">
                        <label for="cat">3D Ref No</label>
                        <input
                          type="text"
                          class="form-control"
                          name="cadReferenceName"
                          value={this.state.cadReferenceName}
                        />
                      </div>
                    )}
                    <div class="form-group pl-2">
                      <label style={{ paddingLeft: "3em" }}>
                        {this.state.cadObj.cadNumber}
                      </label>
                      <div className="upload-photo">
                        <img
                          src={
                            this.state.cadObj.cadImage != ""
                              ? UtilityService.fileUrl() +
                              this.state.cadObj.cadImage
                              : productPic
                          }
                        />
                        {this.state.cadObj.cadImage != "" &&
                          this.state.cadObj.cadImage !== "" ? (
                            ""
                          ) : (
                            <a class="btn-floating btn-small waves-effect waves-light black btn-img-upload">
                              <i class="material-icons input-file-i">add</i>
                            </a>
                          )}
                        <span className="positioing-section">
                          {this.state.cadObj.cadImage != "" &&
                            !this.state.disabled && (
                              <Fragment>
                                <span className="pull-right p-1 edit">
                                  <input
                                    type="file"
                                    className="fileInputs"
                                    onChange={e =>
                                      this.imageUploadForCad(e.target.files)
                                    }
                                  />
                                  <i className="fa fa-edit icon-fa-color print-hidden" />
                                </span>
                                <span className="pull-right p-1 delete">
                                  <i
                                    className="fa fa-trash icon-fa-color print-hidden"
                                    onClick={e => this.removeCadImage(e)}
                                  />
                                </span>
                              </Fragment>
                            )}
                        </span>
                        <input
                          type="file"
                          accept="image/*"
                          className="input-file"
                          name="profilePicture"
                          style={{ display: "none" }}
                          onChange={e => this.imageUploadForCad(e.target.files)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-9 nopadding">
                    <div className="col-md-12 nopadding">
                      <div class="col-md-3 pl-0">
                        <label for="no">Assigned To</label>
                        <div className="custom-async-select">
                          <Async
                            name="assignedTo"
                            value={cadObj.assignedTo}
                            onInputChange={this.searchAssignedTo}
                            onChange={this.getAssignedTo}
                            options={this.state.actionedByOption}
                            disabled={this.state.disabled}
                          />
                        </div>
                      </div>
                      <div class="col-md-3 pl-0">
                        <Field
                          isFormGroup={true}
                          inputType={"text"}
                          inputName={"cadName"}
                          value={cadObj.cadName}
                          label={"3D NAME*"}
                          onChange={this._onChange}
                          disabled={this.state.disabled}
                        />
                      </div>
                      <div class="col-md-3 pl-0">
                        <div className="form-group">
                          <label for="no">3D TYPE<span className="text-danger madatory-asterisk">*</span></label>
                          <Picky
                            value={cadObj.cadType}
                            className={"picky-custom-width"}
                            options={prefillData.CADTYPE}
                            onChange={val => this._handleChangeCadType(val)}
                            open={false}
                            valueKey="value"
                            labelKey="label"
                            multiple={true}
                            includeSelectAll={true}
                            includeFilter={true}
                            dropdownHeight={300}
                            disabled={this.state.disabled}
                          />
                        </div>
                      </div>
                      <div class="col-md-3 pl-0">
                        <Field
                          isFormGroup={true}
                          inputType="select"
                          inputName="basicFabricQuality"
                          value={cadObj.basicFabricQuality}
                          label={"Basic Fabric Quality"}
                          options={prefillData.BASICFABRICQUALITY}
                          onChange={this._onChange}
                          disabled={this.state.disabled}
                        />
                      </div>
                    </div>
                    <div className="col-md-12 nopadding">
                      <div class="col-md-3 pl-0">
                        <Field
                          isFormGroup={true}
                          inputType={"text"}
                          inputName={"storyName"}
                          value={cadObj.storyName}
                          label={"Story / Col Name"}
                          onChange={this._onChange}
                          disabled={this.state.disabled}
                        />
                      </div>
                      <div class="col-md-3 pl-0">
                        <Field
                          isFormGroup={true}
                          inputType="select"
                          inputName="printType"
                          value={cadObj.printType}
                          label={"Print/Emb Type*"}
                          options={prefillData.PRINTEMBTYPE}
                          onChange={this._onChange}
                          disabled={this.state.disabled}
                        />
                      </div>
                      <div class="col-md-2 pl-0">
                        <Field
                          isFormGroup={true}
                          inputType="select"
                          inputName="borderType"
                          value={cadObj.borderType}
                          label={"Border Type"}
                          options={prefillData.BORDERTYPE}
                          onChange={this._onChange}
                          disabled={this.state.disabled}
                        />
                      </div>

                      <div class="col-md-2 pl-0">
                        <Field
                          isFormGroup={true}
                          inputType="select"
                          inputName="category"
                          value={cadObj.category}
                          label={"Category*"}
                          options={prefillData.CATEGORY}
                          onChange={this._onChange}
                          disabled={this.state.disabled}
                        />
                      </div>
                      <div class="col-md-2 pl-0">
                        <Field
                          isFormGroup={true}
                          inputType="select"
                          inputName="seasons"
                          value={cadObj.seasons}
                          label={"seasons"}
                          options={prefillData.SEASONS}
                          onChange={this._onChange}
                          disabled={this.state.disabled}
                        />
                      </div>
                    </div>
                    <div className="col-md-12 nopadding">
                      <div class="col-md-3 pl-0">
                        <div class="form-group">
                          <label for="no">Magnum Style No.</label>
                          <div class="custom-async-select">
                            <Async
                              name="magnumStyleId"
                              value={this.state.cadObj.styleReferenceId}
                              onInputChange={this.getMagnumStyleNo}
                              onChange={this.changeStyleNo}
                              placeholder="Find Style"
                              options={this.state.styleInfo}
                              disabled={this.state.disabled}
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3 pl-0">
                        <div class="form-group">
                          <label for="no">Sample Request No</label>
                          <div class="custom-async-select">
                            <Async
                              name="magnumStyleId"
                              value={this.state.cadObj.sampleRequestId}
                              onInputChange={e => this.getSampleRqNo(e)}
                              onChange={this.changeSampleNo}
                              placeholder="Find Sample"
                              options={this.state.sampleRequestNumbers}
                              disabled={this.state.disabled}
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3 pl-0">
                        {
                          <CustomerDeptSelect
                            options={this.state.customerList}
                            value={`${cadObj.customer}-${cadObj.customerDepartmentId}`}
                            onChange={this._handleCustDeptChange}
                            disabled={this.state.disabled}
                          />
                        }
                      </div>
                      <div class="col-md-3 pl-0">
                        <div class="form-group">
                          <label for="name">Magnum Style Name</label>
                          <input
                            type="text"
                            class="form-control"
                            placeholder=""
                            name="styleName"
                            value={cadObj.magnumStyleName}
                            disabled={this.state.disabled}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 no-padding px-5 mt-2">
                    <FileUpload
                      Heading="Upload Images"
                      moduleName={"cad"}
                      getRefImages={this.getRefImages}
                      disabled={this.state.disabled}
                      uploadedDocs={
                        this.state.cadObj.refImages.length > 0
                          ? this.state.cadObj.refImages
                          : null
                      }
                      imageTypeOption={
                        this.state.prefillData
                          ? this.state.prefillData.IMAGETYPE
                          : []
                      }
                    />
                  </div>
                  <div class="col-md-12 profile-btn text-center">
                    {!this.state.disabled &&
                      this.state.createOption === true &&
                      this.state.cadObj.options.length === 0 && (
                        <button
                          type="button"
                          class="primary"
                          onClick={() => this.createReference()}
                          name="button"
                        >
                          {" "}
                          Create Option
                        </button>
                      )}
                    {!this.state.disabled && (
                      <Fragment>
                        <Button
                          buttonType={"save"}
                          buttonName={"save"}
                          onClick={e => this.checkValidation(e)}
                        />
                        <Button
                          buttonType={"cancel"}
                          buttonName={"cancel"}
                          history={this.props.history}
                        />
                      </Fragment>
                    )}
                  </div>
                </div>
              </form>
              {this.state.cadObj.options.map((cad, index) => (
                <form id={index + 1}>
                  <div
                    class="col-md-12 nopadding"
                    style={{ paddingBottom: "1%" }}
                  >
                    <div class="col-md-12 no-padding">
                      <div class="col-md-12 no-padding">
                        <h6 class="dev-title" style={{ paddingBottom: "10px" }}>
                          <b />
                          {!this.state.disabled ? (
                            index === 0 ? (
                              <Button
                                buttonType={"add"}
                                onClick={() => this.createReference()}
                              />
                            ) : (
                                <Button
                                  buttonType={"remove"}
                                  onClick={() => this.removeCADReference(cad._id)}
                                />
                              )
                          ) : null}
                        </h6>
                      </div>

                      <div class="col-md-2">
                        <div class="col-md-10">
                          <div className="upload-photo">
                            <img
                              src={
                                cad.cadImage != ""
                                  ? UtilityService.fileUrl() + cad.cadImage
                                  : productPic
                              }
                            />
                            {!this.state.disabled ? (
                              cad.cadImage != "" && cad.cadImage !== "" ? (
                                ""
                              ) : (
                                  <a class="btn-floating btn-small waves-effect waves-light black btn-img-upload">
                                    <i class="material-icons input-file-i">add</i>
                                  </a>
                                )
                            ) : null}
                            {!this.state.disabled && (
                              <span className="positioing-section">
                                {cad.cadImage != "" ? (
                                  <Fragment>
                                    <span className="pull-right p-1 edit">
                                      <input
                                        type="file"
                                        className="fileInputs"
                                        onChange={e =>
                                          this.imageUploadCadRefImage(
                                            e.target.files,
                                            index
                                          )
                                        }
                                      />
                                      <i className="fa fa-edit icon-fa-color print-hidden" />
                                    </span>
                                    <span className="pull-right p-1 delete">
                                      <i
                                        className="fa fa-trash icon-fa-color print-hidden"
                                        onClick={e =>
                                          this.removeCadImageOptions(e, index)
                                        }
                                      />
                                    </span>
                                  </Fragment>
                                ) : null}
                              </span>
                            )}
                            {!this.state.disabled && (
                              <input
                                type="file"
                                accept="image/*"
                                className="input-file"
                                name="profilePicture"
                                style={{ display: "none" }}
                                onChange={e =>
                                  this.imageUploadCadRefImage(
                                    e.target.files,
                                    index
                                  )
                                }
                              />
                            )}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-10" style={{ marginBotton: "15px" }}>
                        <div class="col-md-2">
                          {
                            <div class="form-group">
                              <label for="item">CAD Reference</label>
                              <span>
                                <h6>{cad.cadRef}</h6>
                              </span>
                            </div>
                          }
                        </div>
                        <div class="col-md-3">
                          <Field
                            isFormGroup={true}
                            inputType={"text"}
                            inputName={"cadName"}
                            value={cad.cadName}
                            index={index}
                            label={"Cad Name"}
                            onChange={this.updateOptionValue}
                            disabled={this.state.disabled}
                          />
                        </div>

                        <div class="col-md-3">
                          <Field
                            isFormGroup={true}
                            inputType={"select"}
                            inputName={"colourRefFrom"}
                            value={cad.colourRefFrom}
                            index={index}
                            label={"Colour Ref From"}
                            options={
                              this.state.prefillData.COLORREFERENCE || []
                            }
                            onChange={this.updateOptionValue}
                            disabled={this.state.disabled}
                          />
                        </div>
                        <div class="col-md-3">
                          <Field
                            isFormGroup={true}
                            inputType={"text"}
                            inputName={"colourDetails"}
                            value={cad.colourDetails}
                            index={index}
                            label={"Colour Details"}
                            onChange={this.updateOptionValue}
                            disabled={this.state.disabled}
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 px-5 mt-1">
                      {/* Image Upload section Start */}
                      <FileUpload
                        Heading="Upload Images"
                        moduleName={"cad"}
                        getRefImages={this.getCadImages}
                        index={index}
                        disabled={this.state.disabled}
                        uploadedDocs={
                          cad.cadRefImages.length > 0 ? cad.cadRefImages : null
                        }
                        imageTypeOption={[]}
                      />
                      <ButtonCol
                        action={this.state.action}
                        saveFunc={e => this.createReference(e, index)}
                        disabled={this.state.disabled}
                      />
                    </div>
                  </div>
                </form>
              ))}
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default DevelopmentCAD


// WEBPACK FOOTER //
// ./src/pages/developmentCAD/page.js